import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAlignVerticalCenter: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAlignVerticalCenter"><Path d="M20.5 3.5V20.5H3.5V3.5H20.5Z" stroke="currentColor" strokeLinecap="round"/><Path d="M7.5 12H16.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconAlignVerticalCenter;
